import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderSlot as _renderSlot, withModifiers as _withModifiers, vShow as _vShow, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-51bf1e36"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "base-modal" }
const _hoisted_2 = { class: "base-modal__content" }
const _hoisted_3 = {
  key: 0,
  class: "modal-header"
}
const _hoisted_4 = { class: "modal-header__title" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = {
  key: 1,
  class: "modal-footer"
}

import { withDefaults } from "vue";
import IconClose from "@/assets/svgs/icon_close.svg";

interface IProps {
  visible: boolean;
  onClose?: () => void;
  headerText?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'BaseModal',
  props: {
    visible: { type: Boolean, default: false },
    onClose: { type: Function, default: () => {
    return;
  } },
    headerText: {}
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_ctx.headerText)
        ? (_openBlock(), _createElementBlock("header", _hoisted_3, [
            _createElementVNode("h2", _hoisted_4, _toDisplayString(_ctx.headerText), 1),
            _createElementVNode("button", {
              class: "modal-header__close-button",
              onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.onClose && _ctx.onClose(...args)))
            }, [
              _createVNode(_unref(IconClose))
            ])
          ]))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_5, [
        _renderSlot(_ctx.$slots, "default")
      ]),
      (_ctx.$slots.footer)
        ? (_openBlock(), _createElementBlock("footer", _hoisted_6, [
            _renderSlot(_ctx.$slots, "footer")
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", {
      class: "base-modal__overlay",
      onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["stop"]))
    })
  ], 512)), [
    [_vShow, _ctx.visible]
  ])
}
}

})